import styled from 'styled-components';

export default styled.div`
  .table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-gutter: stable;
    width: 100%;
    white-space: nowrap;
    padding-bottom: 2px;
  }

  .table-wrapper::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 10px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.05), transparent);
    pointer-events: none;
    z-index: 100;
  }
`;
